const countUp = (target) => {
	const targetNumbers = target.querySelectorAll('[data-number]');
	targetNumbers.forEach((targetEl) => {
		const targetWrapper = targetEl;
		const targetNumber = targetEl.getAttribute('data-number');
		let startNumber = 0;

		const countUpEl = () => {
			startNumber += targetNumber / 600;
			targetWrapper.textContent = parseInt(startNumber, 10);
			if (startNumber < targetNumber) {
				window.requestAnimationFrame(countUpEl);
			}
		};
		window.requestAnimationFrame(countUpEl);
	});
};

function handleIntersection(entries, observer) {
	entries.forEach((entry) => {
		if (entry.intersectionRatio > 0) {
			countUp(entry.target);
			observer.unobserve(entry.target);
		}
	});
}
const observer = new IntersectionObserver(handleIntersection);

const counter = () => {
	if (document.querySelector('.statistics')) {
		document.querySelectorAll('.statistics').forEach((obs) => {
			observer.observe(obs);
		});
	}
};

export default counter;
